import { Floorplan } from "@domain/project/floorplan/floorplan";
import { FloorplanEventType } from "@domain/project/floorplan/floorplan-event";
import { FloorplanNode } from "@domain/project/floorplan/floorplan-node";
import { Exclude, Expose } from "class-transformer";
import { IsNumber, IsUUID } from "class-validator";
import { v4 as uuidv4 } from "uuid";

export class FloorplanKvmReceiver extends FloorplanNode {
  @IsUUID()
  @Expose({ name: "id" })
  public readonly id: string;

  @Exclude()
  protected _floorplan!: Floorplan;

  @Exclude()
  protected _kvmLocked!: () => boolean;

  @Expose({ name: "size" })
  @IsNumber()
  private _size: number;

  constructor(floorplan: Floorplan, kvmLocked: () => boolean, id: string, x: number, y: number, size: number) {
    super(x, y);
    this.id = id;
    this._size = size;
    this._floorplan = floorplan;
    this._kvmLocked = kvmLocked;
  }

  static create(floorplan: Floorplan, kvmLocked: () => boolean, x: number, y: number, size: number): FloorplanKvmReceiver {
    return new FloorplanKvmReceiver(floorplan, kvmLocked, uuidv4(), x, y, size);
  }

  init(floorplan: Floorplan, kvmLocked: () => boolean) {
    this._floorplan = floorplan;
    this._kvmLocked = kvmLocked;
  }

  get size(): number {
    return this._size;
  }

  set size(size: number) {
    this._size = size;
  }

  updateSize(value: number, x: number, y: number) {
    this._size = value;
    this.updatePosition(x, y);
  }

  override updatePosition(x: number, y: number) {
    super.updatePosition(x, y);
    this._floorplan.publishUpdate(FloorplanEventType.ITEM_UPDATED, this);
  }

  override get locked(): boolean {
    return this._kvmLocked();
  }
}
